// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__wAKd-","typing":"OtpInput_typing__l5EDd","verifying":"OtpInput_verifying__TpyJ5","verified":"OtpInput_verified__Zna1t","error":"OtpInput_error__L51uZ"};